import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IControls } from 'bi-interfaces';
import { IDropDown } from 'bi-interfaces/lib/interfaces/IDropDownList';
import { BiDropDownComponent } from '../bi-drop-down/bi-drop-down.component';

@Component({
  selector: 'bi-floating-drop-down',
  templateUrl: './bi-floating-drop-down.component.html',
  styleUrls: ['./bi-floating-drop-down.component.css']
})
export class BiFloatingDropDownComponent extends BiDropDownComponent {


  @Input() Label?: string;
  @Input() Control!: IControls;
  @Input() override DomId?: any;

  override  selectionChange(event: any) {
    if (event?.[this.TextField] && event?.[this.ValueField]) {
      this.OnselectionChange.emit(event);

    } else {
      if (this.DropDownList) {
        let selectedValue = this.DropDownList.find(el => el[this.ValueField] == event.value)
        this.OnselectionChange.emit(selectedValue)
          ;
      }
    }


  }


}
